module.exports = __webpack_public_path__ + "media/images/front/favicon-32x32-dfc685872ecf71e80eaf8f61e8c2af93.png";